@if (languagesSwitcherEnabled) {
  <dropdown
    [options]="config?.listOfLanguages?.languages"
    [value]="activeLangKey"
    [isMobileView]="isMobileView"
    [displayProperty]="displayProperty"
    [key]="valueKey"
    selectTriggerIcon="language"
    (selectOption)="handleLanguageChange($event)"
    data-test-id="languagesSwitcher"
  ></dropdown>
}
